/**
 * Country-specific variant sales volume sorting
 * Applies when page loads with default or "Featured" sort
 */

// Create a blocking style as early as possible
(function() {
  // Only apply on the target collection
  const path = window.location.pathname;
  if (!path.includes('/collections/tutte-le-calze-uomo')) return;
  
  // Check for filtering in URL
  const query = window.location.search;
  if (query.includes('filter.')) return;
  
  // Check if default (no sort) or "Featured" sort is selected
  const isDefaultOrFeatured = !query.includes('sort_by=') || query.includes('sort_by=manual');
  if (!isDefaultOrFeatured) return;
  
  // Create the hiding style
  const style = document.createElement('style');
  style.id = 'anti-flicker-style';
  style.innerHTML = `
    /* Hide the entire products grid container with maximum specificity */
    html body [data-products-grid] {
      visibility: hidden !important;
      opacity: 0 !important;
    }
    /* Create a loading indicator */
    html body [data-products-grid]::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 30px;
      height: 30px;
      margin: -15px 0 0 -15px;
      border: 3px solid rgba(0,0,0,0.1);
      border-top-color: rgba(0,0,0,0.4);
      border-radius: 50%;
      animation: grid-loader 0.6s linear infinite;
      visibility: visible !important;
      opacity: 1 !important;
    }
    @keyframes grid-loader {
      to { transform: rotate(360deg); }
    }
  `;
  
  // Insert as early as possible
  document.head.appendChild(style);
  
  // Safety timeout - remove the style after 5 seconds no matter what
  setTimeout(function() {
    const antiFlickerStyle = document.getElementById('anti-flicker-style');
    if (antiFlickerStyle) {
      antiFlickerStyle.remove();
    }
  }, 5000);
})();

// Remove the anti-flicker style
function showProductsGrid() {
  const antiFlickerStyle = document.getElementById('anti-flicker-style');
  if (antiFlickerStyle) {
    antiFlickerStyle.remove();
  }
}

// Main initialization
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the target collection
  const path = window.location.pathname;
  if (!path.includes('/collections/tutte-le-calze-uomo')) {
    showProductsGrid();
    return;
  }
  
  // Check if any filter is applied
  if (window.location.search.includes('filter.')) {
    showProductsGrid();
    return;
  }
  
  // Check the current sort
  const urlParams = new URLSearchParams(window.location.search);
  const currentSort = urlParams.get('sort_by');
  
  // Apply custom sorting if it's default (no sort) or "Featured" (manual)
  if (!currentSort || currentSort === 'manual') {
    const countryCode = detectCountryFromUrl();
    //console.log("Detected country:", countryCode);
    sortByVariantSalesVolumeForCountry(countryCode);
  } else {
    showProductsGrid();
  }
  
  // Add a global variable that stores when our custom sorting has been applied
  window.variantSortingApplied = !currentSort || currentSort === 'manual';

  setupPaginationMonitoring();

  // Watch for URL changes to apply our sorting when returning to Featured
  let lastUrl = location.href; 
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      onUrlChange();
    }
  }).observe(document, {subtree: true, childList: true});
  
  function onUrlChange() {
    // Check if we've navigated to Featured sort
    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get('sort_by');
    
    if (path.includes('/collections/tutte-le-calze-uomo') && 
        (!sortBy || sortBy === 'manual') && 
        !params.toString().includes('filter.')) {
      // Only apply if we haven't already sorted
      if (!window.variantSortingApplied) {
        // Hide the grid
        const style = document.createElement('style');
        style.id = 'anti-flicker-style';
        style.innerHTML = `
          html body [data-products-grid] {
            visibility: hidden !important;
            opacity: 0 !important;
          }
        `;
        document.head.appendChild(style);
        
        // Apply our sorting
        const countryCode = detectCountryFromUrl();
        sortByVariantSalesVolumeForCountry(countryCode);
        window.variantSortingApplied = true;
      }
    } else {
      window.variantSortingApplied = false;
    }
  }
});

/**
 * Detects the country from URL path pattern
 * Handles patterns like /fr-fr/, /de-de/, /en-us/, etc.
 * @returns {string} Two-letter country code (it, us, de, gr, gb)
 */
function detectCountryFromUrl() {
  // Default to Italy if no country is detected
  let countryCode = 'it';
  
  // Check for country code in URL path (/fr-fr/, /de-de/, etc.)
  const urlPath = window.location.pathname;
  const pathMatch = urlPath.match(/^\/([a-z]{2}(-[a-z]{2})?)\//i);
  
  if (pathMatch) {
    const localeCode = pathMatch[1].toLowerCase();
    if (localeCode.includes('-')) {
      // Handle format like en-us, fr-fr
      countryCode = localeCode.split('-')[1];
    } else {
      // Handle format like /fr/, /de/
      countryCode = localeCode;
    }
  }
  
  // Normalize some common country codes
  if (countryCode === 'uk') countryCode = 'gb'; // UK's ISO code is actually GB
  
  // Return country code or default to 'it' (Italy)
  return countryCode;
}

/**
 * Map of country codes to metafield suffixes
 * This allows for standardized handling of different country codes
 */
const COUNTRY_METAFIELD_MAP = {
  'it': 'it',    // Italy
  'us': 'us',    // United States
  'de': 'de',    // Germany
  'gr': 'gr',    // Greece
  'gb': 'gb'     // United Kingdom
};

/**
 * Sort products based on country-specific COLOR sales volume (not individual variants)
 * @param {string} countryCode - Two-letter country code
 */
function sortByVariantSalesVolumeForCountry(countryCode) {
  const productsGrid = document.querySelector('[data-products-grid] .js-grid');
  if (!productsGrid) {
    showProductsGrid();
    return;
  }
  
  const productItems = Array.from(productsGrid.querySelectorAll('.product-grid-item'));
  if (productItems.length === 0) {
    showProductsGrid();
    return;
  }
  
  const productSalesData = [];
  
  // Convert country code to metafield suffix
  const metafieldSuffix = COUNTRY_METAFIELD_MAP[countryCode] || 'it';
  
  // Define country attribute name once for the entire function
  const countryAttributeName = `data-variant-sales-volume-${metafieldSuffix}`;
  
  // Group products by product ID to handle multiple colors per product
  const productGroups = new Map();
  
  productItems.forEach(item => {
    const productId = item.getAttribute('data-item-id');
    const colorName = item.getAttribute('data-color-name');
    
    if (!productGroups.has(productId)) {
      productGroups.set(productId, {
        colors: [],
        elements: []
      });
    }
    
    productGroups.get(productId).colors.push(colorName);
    productGroups.get(productId).elements.push(item);
  });
  
  // For debugging - store detailed color sales data
  const debugColorData = [];
  
  // Store all color-product combinations as separate items
  const colorProductData = [];
  
  // For each product, process each color as a separate item
  productGroups.forEach((productData, productId) => {
    // Store all color sales for this product (for debugging)
    const productColorSales = [];
    
    productData.elements.forEach(colorElement => {
      // Find all variants for this color and sum their sales volumes
      const colorName = colorElement.getAttribute('data-color-name');
      const debugSwatchOption = colorElement.getAttribute('data-debug-swatch-option');
      let colorTotalSales = 0;
      
      // Get the variant data from the data attribute
      const variantDataAttr = colorElement.getAttribute('data-color-variants');
      
      //console.log(`\n🔍 DEBUGGING COLOR: ${colorName} (Product: ${productId})`);
      //console.log('Debug swatch option:', debugSwatchOption);
      //console.log('Variant data attribute:', variantDataAttr);
      
      let variantDetails = [];
      
      if (variantDataAttr) {
        try {
          const variants = JSON.parse(variantDataAttr);
          //console.log(`Found ${variants.length} variants in data attribute`);
          
          variants.forEach((variant, index) => {
            // Get sales volume for the current country
            let salesVolume = 0;
            
            switch (metafieldSuffix) {
              case 'it':
                salesVolume = variant.sales_it || 0;
                break;
              case 'us':
                salesVolume = variant.sales_us || 0;
                break;
              case 'de':
                salesVolume = variant.sales_de || 0;
                break;
              case 'gr':
                salesVolume = variant.sales_gr || 0;
                break;
              case 'gb':
                salesVolume = variant.sales_gb || 0;
                break;
              default:
                salesVolume = variant.sales_global || 0;
            }
            
            colorTotalSales += salesVolume;
            
            // Store variant details for debugging
            variantDetails.push({
              variantId: variant.id,
              salesVolume: salesVolume,
              countrySpecific: variant[`sales_${metafieldSuffix}`] || 0,
              globalSales: variant.sales_global || 0,
              allCountryData: {
                it: variant.sales_it || 0,
                us: variant.sales_us || 0,
                de: variant.sales_de || 0,
                gr: variant.sales_gr || 0,
                gb: variant.sales_gb || 0,
                global: variant.sales_global || 0
              }
            });
          });
          
        } catch (error) {
          console.error('Error parsing variant data:', error);
        }
      } else {
        //console.log('No variant data found - falling back to old method');
        
        // Fallback to old method if no structured data
        const variantElements = colorElement.querySelectorAll(`[${countryAttributeName}], [data-variant-sales-volume]`);
        
        variantElements.forEach(variantElement => {
          const salesVolume = parseInt(
            variantElement.getAttribute(countryAttributeName) || 
            variantElement.getAttribute('data-variant-sales-volume'), 
            10
          ) || 0;
          colorTotalSales += salesVolume;
          
          variantDetails.push({
            element: variantElement,
            salesVolume: salesVolume,
            countryAttribute: variantElement.getAttribute(countryAttributeName),
            globalAttribute: variantElement.getAttribute('data-variant-sales-volume')
          });
        });
      }
      
      //console.log(`Total sales for ${colorName}: ${colorTotalSales}`);
      //console.log('Variant details:', variantDetails);
      
      // Store color sales data for debugging
      productColorSales.push({
        colorName: colorName,
        totalSales: colorTotalSales,
        variantCount: variantDetails.length,
        variantDetails: variantDetails
      });
      
      // Get product title for debugging
      const productTitle = productData.elements[0]?.querySelector('[data-grid-link]')?.getAttribute('aria-label') || 
                          productData.elements[0]?.getAttribute('aria-label') || 
                          `Product ${productId}`;
      
      // CHANGED: Store each color as a separate item for sorting
      colorProductData.push({
        element: colorElement,
        salesVolume: colorTotalSales,
        productId: productId,
        productTitle: productTitle,
        colorName: colorName,
        variantDetails: variantDetails
      });
    });
    
    // Store debug data (for debugging display)
    debugColorData.push({
      productId: productId,
      productTitle: productData.elements[0]?.querySelector('[data-grid-link]')?.getAttribute('aria-label') || 
                   productData.elements[0]?.getAttribute('aria-label') || 
                   `Product ${productId}`,
      allColorSales: productColorSales,
      totalColors: productColorSales.length
    });
  });
  
  // Sort all color-product combinations by sales volume (highest first)
  colorProductData.sort((a, b) => b.salesVolume - a.salesVolume);
  
  // DEBUG: Log top 20 product-color combinations
  //console.log(`\n🎯 TOP 20 PRODUCT-COLOR COMBINATIONS (Country: ${countryCode.toUpperCase()})`);
  //console.log('=' .repeat(80));
  /*
  colorProductData.slice(0, 338).forEach((item, index) => {
    console.log(`\n${index + 1}. ${item.productTitle} - ${item.colorName}`);
    console.log(`   Product ID: ${item.productId}`);
    console.log(`   🏆 Color Sales: ${item.salesVolume}`);
    console.log(`   Variants: ${item.variantDetails.length}`);
    
    // Show variant details for top 5 items
    if (index < 5) {
      console.log(`   Variant breakdown:`);
      item.variantDetails.forEach((variant, vIndex) => {
        console.log(`     - Variant ${vIndex + 1} (ID: ${variant.variantId}): ${variant.salesVolume} sales`);
        console.log(`       Country-specific (${metafieldSuffix}): ${variant.countrySpecific}`);
        console.log(`       Global: ${variant.globalSales}`);
      });
    }
  
  });
  */
  
  //console.log('\n' + '='.repeat(80));
  //console.log(`Total product-color combinations: ${colorProductData.length}`);
  //console.log(`Country metafield suffix: ${metafieldSuffix}`);
  //console.log(`Looking for attribute: data-variant-sales-volume-${metafieldSuffix}`);
  
  // Reorder the products in the DOM
  const fragment = document.createDocumentFragment();
  colorProductData.forEach(item => {
    // Add each color-product combination as a separate item
    let containerElement = item.element;
    
    // Check if element is wrapped in collection containers
    const parent = item.element.parentNode;
    if (parent && (parent.classList.contains('collection-list__product') || 
                  parent.hasAttribute('data-item') || 
                  parent.classList.contains('slide-item'))) {
      containerElement = parent;
    }
    
    fragment.appendChild(containerElement);
  });
  
  // Clear and add the sorted products
  while (productsGrid.firstChild) {
    productsGrid.removeChild(productsGrid.firstChild);
  }
  productsGrid.appendChild(fragment);
  
  // Show the grid after sorting is complete
  setTimeout(() => {
    showProductsGrid();
  }, 10);
  
  //console.log(`\n✅ Sorted ${colorProductData.length} product-color combinations by sales volume for country: ${countryCode}`);
}

/**
 * Monitor for AJAX pagination and re-apply sorting
 */
function setupPaginationMonitoring() {
  const productsContainer = document.querySelector('[data-products-grid], .collection__products');
  if (!productsContainer) {
    //console.log('❌ Products container not found for monitoring');
    return;
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if the .js-grid was replaced (pagination)
      if (mutation.type === 'childList' && 
          mutation.addedNodes.length > 0 && 
          mutation.removedNodes.length > 0) {
        
        // Look for .js-grid in added nodes
        const hasNewGrid = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('js-grid') || 
            node.querySelector?.('.js-grid')
          )
        );

        if (hasNewGrid) {
          //console.log('🔄 New product grid detected, re-applying sorting...');
          
          // Wait for content to fully load, then re-apply sorting
          setTimeout(() => {
            const path = window.location.pathname;
            if (path.includes('/collections/tutte-le-calze-uomo') && 
                !window.location.search.includes('filter.')) {
              
              const urlParams = new URLSearchParams(window.location.search);
              const currentSort = urlParams.get('sort_by');
              
              if (!currentSort || currentSort === 'manual') {
                const countryCode = detectCountryFromUrl();
                //console.log('Re-applying sorting for country:', countryCode);
                //console.log('Current page:', urlParams.get('page') || '1');
                sortByVariantSalesVolumeForCountry(countryCode);
              }
            }
          }, 200); // Small delay to ensure content is ready
        }
      }
    });
  });

  observer.observe(productsContainer, {
    childList: true,
    subtree: true
  });

  //console.log('✅ Pagination monitoring set up');
}